/*
 * @Descripttion:
 * @version: 1.1.1
 * @Author: xiaoan
 * @Date: 2022-06-29 20:38:36
 * @LastEditors: xiaoan
 * @LastEditTime: 2022-07-27 19:07:18
 */

export function validURLa(str) {
  const pattern = new RegExp('^(https?:\\/\\/)?' // protocol

      + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name

      + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address

      + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path

      + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string

      + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

  return !!pattern.test(str);
}

export function isNumber(val) {
  const regPos = /^\d+(\.\d+)?$/; // 非负浮点数
  const regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; // 负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true;
  }
  return false;
}

/* export function validURL(URL) {
  const str = URL;
  const Expression = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- ./?%&=]*)?/;
  const objExp = new RegExp(Expression);
  if (objExp.test(str) === true) {
    return true;
  }
  return false;
} */

export function validURL(pattern) {
  function slashClear(str) {
    let string = str;
    if (str.charAt(str.length - 1) === '/') string = str.substring(0, str.length - 1);
    return string;
  }
  try {
    const _pattern = slashClear(pattern);
    const decoded = decodeURIComponent(_pattern);
    const url = new URL(decoded);
    return slashClear(url.toString()) === decoded;
  } catch (error) {
    return false;
  }
}

export function getQueryVariable(variable) {
  const query = window.location.search.substring(1);
  const vars = query.split('&');
  for (let i = 0; i < vars.length; i += 1) {
    const pair = vars[i].split('=');
    if (pair[0] === variable) {
      return decodeURI(pair[1]);
    }
  }
  return '';
}
